import Entity from "./Entity";

export default class MapObjectStatus extends Entity {
    constructor(data, availableOnMap = true) {
        super(data);
        this.availableOnMap = availableOnMap

        this.attributeKeys = [
            "id", "mapObjectStatusTemplateId", "mapObjectId", "lastUpdate", "mapIds", "statusString"
        ];
    }
}
